<template>
  <div >

    <div v-if="isEdit === false" style="text-align: right">
      <el-button type="warning" plain @click="btnEditClick">编辑</el-button>
      <el-button type="danger" plain @click="btnDelClick">删除</el-button>
    </div>

    <div v-if="isEdit === false">

      <div style="text-align: center;margin: 10px 0">
        <div class="title">{{blogData.title}}</div>
        <div class="react topping" v-if="blogData.topping === true">置顶</div>
        <div class="react essence" v-if="blogData.essence === true">精华</div>
      </div>

      <div style="text-align: center;margin: 10px 0">
        <div v-for="item in blogData.tags" :key="item.id" style="display: inline-block;margin: 10px 5px">
          <div class="react-tag" :style="getColorStyle(item.tag_col)">{{item.tag_name}}</div>
        </div>
      </div>

      <div  style="text-align: center;margin: 10px 0">
        <div class="time">创建时间：{{formatDate(blogData.create_blog_time)}}</div>
        <div class="time" v-if="blogData.create_blog_time !== blogData.last_update_time">最后修改时间：{{formatDate(blogData.last_update_time)}}</div>
      </div>

    </div>

    <div v-else>

      <div style="margin: 10px 0">
        <el-input
          placeholder="请输入内容"
          v-model="blogData.title"
          clearable>
        </el-input>
      </div>

      <div style="margin: 10px 0">
        <div style="display: inline-block;width: 500px;margin-right: 20px">
          <el-select
            v-model="chooseTags"
            multiple
            filterable
            default-first-option
            placeholder="请选择文章标签"
            style="width: 100%">
            <el-option
              v-for="item in tags"
              :key="item.id"
              :label="item.tag_name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>

        <div style="display: inline-block;margin-right: 5px">置顶</div>
        <div style="display: inline-block;margin-right: 20px">
          <el-switch
            v-model="blogData.topping"
            active-color="dodgerblue"
            inactive-color="#909090">
          </el-switch>
        </div>

        <div style="display: inline-block;margin-right: 5px">精华</div>
        <div style="display: inline-block;margin-right: 20px">
          <el-switch
            v-model="blogData.essence"
            active-color="red"
            inactive-color="#909090">
          </el-switch>
        </div>

        <div style="display: inline-block;margin-right: 5px">隐私</div>
        <div style="display: inline-block;margin-right: 20px">
          <el-switch
            v-model="blogData.hidden"
            active-color="orange"
            inactive-color="#909090">
          </el-switch>
        </div>

        <div style="display: inline-block;float: right">
          <el-button type="success" plain @click="btnDoneClick">完成</el-button>
        </div>
      </div>

    </div>

    <div style="margin-top: 30px">
      <MavonEditor ref="MavonEditor"></MavonEditor>
    </div>

  </div>
</template>

<script>

import MavonEditor from '../../../widgets/MavonEditor'
import {getBlogDetail, delBlog, getBlogTagList, updateBlog} from '../../../../../request/api'
import Common from '../../../../../js/Common'
import Utils from '../../../../../js/Utils'

export default {
  name: 'BackBlogInfo',
  components: {MavonEditor},
  data () {
    return {
      UserAuthType_Admin: Common.UserAuthType.UserAuthType_Admin,
      blogData: {},
      isEdit: false, // 编辑状态
      tags: [], // blog标签数据
      chooseTags: [] // blog输入的标签
    }
  },
  methods: {
    init () {
      var params = {'blog_id': this.$route.query.blog_id}

      getBlogDetail(params).then(res => {
        console.log(res)

        if (res.code === '90') {
          this.blogData = res.data

          this.$refs.MavonEditor.blogid = this.blogData.id
          this.$refs.MavonEditor.content = this.blogData.content

          if (this.blogData.tags !== null) {
            for (var i = 0; i < this.blogData.tags.length; i++) {
              var tagItem = this.blogData.tags[i]
              this.chooseTags.push(tagItem.id)
            }
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        // error

        console.log(error)
      })

      getBlogTagList().then(res => {
        console.log(res)

        if (res.code === '90') {
          this.tags = res.data
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        // error
        console.log(error)
      })
    },

    btnEditClick () {
      this.isEdit = true
      this.$refs.MavonEditor.defaultOpen = ''
      this.$refs.MavonEditor.toolbarsFlag = true
      this.$refs.MavonEditor.editable = true
      this.$refs.MavonEditor.subfield = true
    },
    btnDelClick () {
      this.$confirm('此操作将永久删除该Blog及所含图片, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var params = {'blog_id': this.$route.query.blog_id}

        delBlog(params).then(res => {
          console.log(res)

          if (res.code === '90') {
            this.$router.push('/back/blog_manage')

            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          } else {
            this.$message.error(res.msg)
          }
        }).catch((error) => {
          // error

          console.log(error)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },

    btnDoneClick () {
      this.isEdit = false
      this.$refs.MavonEditor.defaultOpen = 'preview'
      this.$refs.MavonEditor.toolbarsFlag = false
      this.$refs.MavonEditor.editable = false
      this.$refs.MavonEditor.subfield = false

      var params = {'blog_id': this.$route.query.blog_id, 'title': this.blogData.title, 'tags': this.chooseTags, 'content': this.$refs.MavonEditor.content, 'topping': this.blogData.topping, 'essence': this.blogData.essence, 'hidden': this.blogData.hidden}

      console.log(params)

      updateBlog(params).then(res => {
        console.log(res)

        if (res.code === '90') {
          this.$message({
            type: 'success',
            message: '修改成功!'
          })
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        // error

        console.log(error)
      })
    },

    formatDate (dateStr) {
      return Utils.formatDate(dateStr)
    },
    getColorStyle (color) {
      return 'background-color:' + color
    }

  },
  created () {
    this.init()
  }
}
</script>

<style scoped>

.title{
  display: inline-block;
  font-size: 28px;
  font-weight: bold;
  /*margin-top: 6px;*/
  margin-right: 10px;
}

.time{
  color: #909399;
  display: inline-block;
  margin: 0 20px;
}

.topping{
  background: dodgerblue;
}
.essence{
  background: red;
}

.react {
  padding: 3px 10px;
  margin-right: 5px;
  margin-bottom: -5px;
  display: inline-block;
  font-size: 12px;
  border-radius: 5px;
  color: white;
}

.react-tag{
  /*width: 50px;*/
  /*height: 26px;*/
  padding: 3px 10px;
  margin-right: 5px;
  text-align: center;
  /*transform: skewX(-20deg);*/
  /*margin-top: 8.5px;*/
  display: inline-block;
  font-size: 12px;
  border-radius: 5px;
  color: white;
}

.circular{
  border-radius: 12px;
  border:0px solid white;
  width: 22px;
  height: 22px;
  display: inline-block;
  /*margin-right: -10px;*/
  /*margin-top: 8px;*/
}
</style>



// WEBPACK FOOTER //
// src/components/pc/pages/back/blog/BackBlogInfo.vue